export default __webpack_public_path__ + "static/media/dl4j.26fdac09.svg";